import { EventArgs } from 'react-ga';
import TagManager from 'react-gtm-module';
import { useLocation } from 'react-router-dom';
import { EventDetails, TrackingEvents, TrackingStage } from '@/config/tracking';
import { useTrackingLocation } from './useTrackingLocation';

type Args = Pick<EventArgs, 'category' | 'action' | 'label'> &
  Partial<Pick<EventArgs, 'value' | 'nonInteraction'>>;

type Analytics = {
  track: (eventArgs: Args) => void;
  trackEvent: (args: TrackingData) => void;
};

export type TrackingData = {
  event: string;
  event_detail: string;
  stage: string;
  search_term?: string;
  event_from?: string;
  event_detail_from?: string;
  stage_from?: string;
};

export const useAnalytics = (): Analytics => {
  const trackingLocation = useTrackingLocation();
  const { key: locationKey, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const originParam = searchParams.get('origin');

  const track = (eventArgs: Args) => {
    TagManager.dataLayer({
      dataLayer: {
        event: eventArgs.action,
        ...eventArgs,
      },
    });
  };

  const trackEvent = (props: TrackingData) => {
    const locationState = trackingLocation ?? {};

    const { referrer } = document;
    const isDirectEntry = Boolean(referrer && new URL(referrer).origin !== window.location.origin);

    const hasAppNavigation = locationKey !== 'default' || props.event_detail_from;
    const isExternal = Boolean(originParam || isDirectEntry || !hasAppNavigation);

    const externalTracking = isExternal
      ? (() => {
          let eventDetailFrom: string | null = 'direct_link';
          let eventFrom: string | null = 'direct_link';

          if (originParam) {
            if (originParam === 'email') {
              if (props.event_detail_from) {
                eventDetailFrom = props.event_detail_from;
                eventFrom = props.event_from ?? null;
              } else {
                eventDetailFrom = null;
                eventFrom = null;
              }
            } else {
              eventDetailFrom = originParam;
              eventFrom = 'unknown';
            }
          }

          return {
            event_detail_from: eventDetailFrom,
            event_from: eventFrom,
            stage_from: TrackingStage.connection,
          };
        })()
      : {};

    const trackingData = isExternal
      ? {
          ...props,
          ...externalTracking,
        }
      : {
          ...locationState,
          ...props,
        };

    console.log(trackingData);

    TagManager.dataLayer({
      dataLayer: trackingData,
    });
  };

  return {
    track,
    trackEvent,
  };
};
